export const PRICE_CHANGE_REASON = {
  OTHER: 'drugo',
  INITIAL_PRICE_SETTING: 'dolocitev_prodajne_cene',
} as const;
